import { JSX } from 'react'

import { IconProps } from '../../icon'

const Content: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40.0974 13.1238C38.9979 12.0899 36.6677 10.3012 33.3036 10.0387C29.4964 9.71045 26.6082 11.5484 25.2297 12.6643C25.0985 12.7628 24.9015 12.7792 24.7703 12.6643C23.3918 11.5484 20.52 9.72686 16.6964 10.0387C13.3323 10.3176 10.9856 12.0899 9.90256 13.1238C9.32821 13.6653 9 14.4202 9 15.2079V33.3248C9 34.2602 9.45949 35.1464 10.2144 35.6879C10.9692 36.2294 11.9046 36.3607 12.7744 36.0653C14.0708 35.6222 15.4328 35.3925 16.7621 35.4417C19.6831 35.5238 21.9313 36.7053 23.2933 37.7064C23.8021 38.0674 24.3928 38.2643 25 38.2643C25.6072 38.2643 26.1979 38.0838 26.7067 37.7064C28.0687 36.7217 30.3169 35.5238 33.2379 35.4417C34.5836 35.3925 35.9292 35.6222 37.2256 36.0653C38.0954 36.3607 39.0308 36.2294 39.7856 35.6879C40.5405 35.1464 41 34.2602 41 33.3248V15.2079C41 14.4038 40.6882 13.6653 40.0974 13.1238ZM16.8277 32.9966C16.7128 32.9966 16.5979 32.9966 16.4667 32.9966C14.9405 32.9966 13.4308 33.2428 11.9703 33.7515C11.8226 33.8007 11.7241 33.7515 11.6421 33.7022C11.5928 33.6694 11.4615 33.5381 11.4615 33.3412V15.2079C11.4615 15.093 11.5108 14.9946 11.5928 14.9125C12.4462 14.092 14.2841 12.6971 16.8933 12.4838C19.7159 12.2705 21.8821 13.4848 23.2113 14.5679C23.3754 14.6992 23.5723 14.7812 23.7692 14.8797V35.0971C22.1118 34.0797 19.7651 33.0787 16.8277 33.013V32.9966ZM38.5385 33.3248C38.5385 33.5381 38.4072 33.653 38.3415 33.6858C38.2759 33.7351 38.161 33.7843 38.0133 33.7351C36.438 33.1935 34.7969 32.9474 33.1559 32.9802C30.2185 33.0622 27.8718 34.0469 26.2144 35.0643V14.8633C26.3949 14.7648 26.5918 14.6992 26.7559 14.5515C28.0851 13.4684 30.2513 12.254 33.0738 12.4674C35.6831 12.6807 37.521 14.0756 38.3744 14.8961C38.4564 14.9781 38.5056 15.0766 38.5056 15.1915V33.3084L38.5385 33.3248Z'
      fill='black'
    />
  </svg>
)

export default Content
